import React, { useState, forwardRef, useImperativeHandle } from 'react'

import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
const currencies_water_body = [
  {
    value: '1',
    label: 'РСК Голодяевский',
  },
  {
    value: '2',
    label: 'РСК Кужора',
  },
  {
    value: '3',
    label: 'РСК Клондайк',
  },
  {
    value: '4',
    label: 'Каневской',
  },
  {
    value: '5',
    label: 'Белый лис',
  },
  {
    value: '6',
    label: 'Высокополье',
  },
  {
    value: '7',
    label: 'РСК Павловский',
  },
  {
    value: '8',
    label: 'РСК Борисов Пруд',
  },
  {
    value: '9',
    label: 'Украинка',
  },
  {
    value: '10',
    label: 'РСК Стадион',
  },
  {
    value: '11',
    label: 'Улово',
  },
  {
    value: '12',
    label: 'РСК Камень',
  },
  {
    value: '13',
    label: 'Просянка',
  },
  {
    value: '14',
    label: 'Золотой берег',
  },
  {
    value: '15',
    label: 'Гавриловcкий',
  },
  {
    value: '16',
    label: 'Братковка',
  },
  {
    value: '17',
    label: 'Рыбхоз Клецова ',
  },
  {
    value: '18',
    label: 'Шумихинское водохранилище д. Береговая',
  },
  {
    value: '19',
    label: 'Рыбохоз Дикая Калуга',
  },
]

export function findLabelByValue(value) {
  const foundItem = currencies_water_body.find((item) => item.value === value)
  return foundItem ? foundItem.label : null
}
const WaterBody = forwardRef(({ defaultvar = '' }, ref) => {
  const [value, setValue] = React.useState(defaultvar)
  const [error, setError] = useState('')
  const val = () => {
    return value
  }
  const validate = () => {
    if (!value) {
      setError('Выберите водоем')
      return false
    }
    if (!value || value.trim() === '') {
      setError('Выбор водоема обязателен')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))

  return (
    <TextField
      id="water_body"
      select
      label="Выбор водоема"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      helperText="Если водоема нет в списке - обратиться в поддержку"
      variant="filled"
      error={!!error}
    >
      {currencies_water_body.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
})

export default WaterBody
